import CandidateCard from './CandidateCard';

const DropCard = ({
  item,
  value,
  id,
  candidates = [],
  drop,
  dragStart,
  dragEnter,
  dropable = true,
}) => {
  return (
    <div
      className="flex min-h-[50vh] w-[279px] shrink-0 grow flex-col items-center bg-blue-100"
      onDragOver={(e) => e.preventDefault()}
      onDragEnd={() => drop()}
      onDragEnter={() => dragEnter(id)}
    >
      <div className="flex space-x-4">
        <div className="py-8 text-2xl font-medium">
          {item.title} ({value})
        </div>
      </div>
      <div className="space-y-2 space-y-reverse">
        {candidates.map((item) => (
          <CandidateCard
            key={item._id}
            name={item.employee}
            exp={item.totalExp}
            score={item.score}
            time={item.applicationDate}
            skill={item?.skills}
            designation={item?.existingRole}
            currentCTC={item?.currentCTC}
            expectedCTC={item?.expectedCTC}
            rejectedReason={item?.rejectedReason}
            declinedReason={item?.declinedReason}
            isDeclined={item?.declined}
            onDragStart={() => dragStart(item._id, id)}
            dropable={dropable}
          />
        ))}
      </div>
    </div>
  );
};

export default DropCard;
